import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { PurchaseOrder } from "features/PurchaseOrders/types/purchase-order.types";

interface CancelModalProps {
  show?: boolean;
  onCancelClick?: () => void;
  onCloseClick?: () => void;
  record?: PurchaseOrder | null;
}

const CancelModal = ({
  show,
  onCancelClick,
  onCloseClick,
  record,
}: CancelModalProps) => {
  return (
    <React.Fragment>
      <Modal fade={true} isOpen={show} toggle={onCloseClick} centered>
        <ModalHeader className="modal-title">#{record?.code}</ModalHeader>
        <ModalBody className="text-center p-5">
          <i className="ri-close-circle-line display-5 text-danger"></i>
          <div className="mt-4">
            <h4 className="mb-3">Confirm cancellation</h4>
            <p className="text-muted mb-4">
              Cancelling stops further goods receipts for this order. The server
              rejects cancellation if any GRN has already been posted.
            </p>
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={onCloseClick}>
                Back
              </Button>
              <Button color="danger" type="button" onClick={onCancelClick}>
                Cancel purchase order
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default CancelModal;
